import { useState, useEffect } from "react";
import { recordToJs } from "componentsv2/tools/functions";

import proxy from "api/proxy";

function useSearch({ model, domain, fieldsNames, limit, type }) {
  let initialData = [];
  if (type === "Map") {
    initialData = new Map();
  }
  const [data, setData] = useState(initialData);

  async function fetchData() {
    const { data } = await proxy.search(model, domain, fieldsNames, limit);
    let _data = data;
    if (type === "Map") {
      _data = new Map();
      data.forEach((rec) => _data.set(rec.id, rec));
    } else if (limit === 1) {
      _data = recordToJs(data[0]);
    }
    setData(_data);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return data;
}

export { useSearch };
